import { useCurrentUser } from '../hooks/users/queries';

// Hook that uses useCurrentUser to get formatted intercom data
export const useIntercomData = () => {
  const { data: user, isLoading } = useCurrentUser();
  
  if (isLoading || !user) {
    return {};
  }
  
  if (!user.id || !user.email) {
    return {};
  }
  
  return {
    user_id: user.id,
    email: user.email,
    name: user.name,
    user_hash: user.intercom,
  };
};

export default useIntercomData;